module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAXklEQVRYw+3RwQmAQAxE0elKLUzwIqZkrSC6J69ZYRYP/xUwHxIJQKeMDO98E975ZvPOnzkxzzzzzL/zH5jn/xCwn2jAk8cnLhLVxEyillhIVBKr5Ezs8nkShwB0ugFetjhmrDaVmQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Actionbar/ic_arrow_back_white_24dp_2x.png
// module id = 57
// module chunks = 0